import React, { useCallback } from 'react';
import {
  Card,
  Table,
  Tag,
  Row,
  Col,
  Typography,
  Empty,
  Tooltip,
  Space,
} from 'antd';
import { useInfiniteScroll } from '../../hooks/useInfiniteScroll';
import { getVirtualCards } from '../../services/cardService';
import { formatDate } from '../../utils/format';

const { Title } = Typography;

const VirtualCards = () => {
  const fetchCards = useCallback(async (cursor) => {
    const response = await getVirtualCards(cursor);
    return {
      data: response.cards || [],
      next_cursor: response.next_cursor
    };
  }, []);

  const { data: cards, loading, error } = useInfiniteScroll(fetchCards);

  const columns = [
    {
      title: 'Card Number',
      key: 'card_number',
      width: 180,
      render: (_, record) => (
        <Space>
          <span><Tag>{record.bin}</Tag> •••• {record.last_four}</span>
        </Space>
      ),
    },
    {
      title: 'Holder Name',
      dataIndex: 'holder_name',
      key: 'holder_name',
      width: 180,
      ellipsis: true,
    },
    {
      title: 'Brand',
      dataIndex: 'brand',
      key: 'brand',
      width: 120,
      render: (brand) => (
        <Tag color="blue">{brand.toUpperCase()}</Tag>
      ),
    },
    {
      title: 'Issuer',
      dataIndex: 'issuer',
      key: 'issuer',
      width: 150,
      ellipsis: true,
    },
    {
      title: 'Expiry',
      key: 'expiry',
      width: 120,
      render: (_, record) => (
        `${record.expiry_month}/${record.expiry_year}`
      ),
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      width: 120,
      render: (status) => {
        const color = 
          status === 'active' ? 'success' :
          status === 'inactive' ? 'default' :
          'error';
        return <Tag color={color}>{status.toUpperCase()}</Tag>;
      },
    },
    {
      title: 'Currency',
      dataIndex: 'currency',
      key: 'currency',
      width: 100,
      render: (currency) => (
        <Tag color="purple">{currency}</Tag>
      ),
    },
    {
      title: 'Created',
      dataIndex: 'created',
      key: 'created',
      width: 120,
      render: (timestamp) => formatDate(timestamp),
    },
  ];

  return (
    <div className="layout-content">
      <Card bordered={false}>
        <Row justify="space-between" align="middle" style={{ marginBottom: 24 }}>
          <Col>
            <Title level={4} style={{ margin: 0 }}>Virtual Cards</Title>
          </Col>
        </Row>

        <Table
          dataSource={cards}
          columns={columns}
          rowKey="id"
          loading={loading && cards.length === 0}
          pagination={false}
          scroll={{ x: 1090 }}
          locale={{
            emptyText: error ? (
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description={error}
              />
            ) : (
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description="No virtual cards found"
              />
            ),
          }}
        />
      </Card>
    </div>
  );
};

export default VirtualCards;
